import { sha256 } from "js-sha256";
export const getLevel = (storedLevel: string) => {
  let hashToken: string = process.env.REACT_APP_SECRET_HASH_TOKEN as string;
  if (sha256(hashToken + "1") === storedLevel) return 1;
  if (sha256(hashToken + "2") === storedLevel) return 2;
  if (sha256(hashToken + "3") === storedLevel) return 3;
  return 0;
};
